export default __webpack_public_path__ + "static/media/b10.4fcf363e.jpg";